module.exports = __webpack_public_path__ + "img/vms_ico_2.012bc2a4.svg";